import React from 'react';
import { Button, Chip, Paper, Stack, Typography } from '@mui/material';
import type { SpecimenTaxonomy } from './taxonomyDatabase';

interface SpecimenCardProps {
  specimen: SpecimenTaxonomy;
  selected?: boolean;
  hiddenIdentity?: boolean;
  onSelect: (specimenId: string) => void;
}

const SpecimenCard: React.FC<SpecimenCardProps> = ({ specimen, selected = false, hiddenIdentity = false, onSelect }) => (
  <Paper variant="outlined" sx={{ p: 1, borderRadius: 1, borderColor: selected ? '#087e72' : '#d4e2dc', minWidth: 178 }}>
    <Stack spacing={0.75}>
      <Typography variant="subtitle2" fontWeight={800}>{hiddenIdentity ? 'Unknown specimen' : specimen.commonName}</Typography>
      {!hiddenIdentity && <Typography variant="caption"><i>{specimen.scientificName}</i></Typography>}
      <Stack direction="row" spacing={0.5} flexWrap="wrap"><Chip size="small" label={specimen.fiveKingdom} /><Chip size="small" variant="outlined" label={specimen.domain} /></Stack>
      <Button size="small" variant={selected ? 'contained' : 'outlined'} onClick={() => onSelect(specimen.id)} aria-pressed={selected}>{selected ? 'On viewing stage' : 'Place on stage'}</Button>
    </Stack>
  </Paper>
);

export default SpecimenCard;
